import React, { useId } from "react";

type AssinaturaPenAnimacaoProps = {
  tone?: "primary" | "emerald";
  className?: string;
};

const SIGNATURE_PATH =
  "M8 42 C32 14, 58 46, 86 28 S142 20, 178 30 S208 18, 216 24";

const AssinaturaPenAnimacao: React.FC<AssinaturaPenAnimacaoProps> = ({
  tone = "primary",
  className = "",
}) => {
  const shadowId = useId().replace(/:/g, "");
  const strokeClass = tone === "emerald" ? "text-emerald-600" : "text-primary";
  const glowClass =
    tone === "emerald" ? "text-emerald-400" : "text-primary-light";
  const nibClass = tone === "emerald" ? "text-emerald-700" : "text-primary-dark";

  return (
    <div
      className={`relative mx-auto h-[4.5rem] w-full max-w-[280px] ${className}`}
      aria-hidden
    >
      <svg
        viewBox="0 0 224 56"
        className="h-full w-full overflow-visible"
        role="presentation"
      >
        <defs>
          <filter id={shadowId} x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="1" stdDeviation="1.2" floodOpacity="0.35" />
          </filter>
        </defs>

        <path
          d={SIGNATURE_PATH}
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${glowClass} [stroke-dasharray:320] animate-assinatura-traco-glow`}
        />
        <path
          d={SIGNATURE_PATH}
          fill="none"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${strokeClass} [stroke-dasharray:320] animate-assinatura-traco`}
        />

        <g
          className="animate-assinatura-caneta"
          style={{ filter: `url(#${shadowId})` }}
        >
          <g className="origin-center animate-assinatura-caneta-press">
            <path
              d="M0 -16 L5 -17 L7 -4 L2 -3 Z"
              className="fill-neutral-700"
            />
            <path
              d="M2 -3 L0 5 L5 3 Z"
              className={nibClass}
              fill="currentColor"
            />
            <ellipse
              cx="3.5"
              cy="-10"
              rx="1.2"
              ry="3.5"
              className="fill-neutral-500"
              opacity="0.5"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default AssinaturaPenAnimacao;
